import { render, staticRenderFns } from "./text-underline.vue?vue&type=template&id=47c86822&scoped=true&"
var script = {}
import style0 from "./text-underline.vue?vue&type=style&index=0&id=47c86822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c86822",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47c86822')) {
      api.createRecord('47c86822', component.options)
    } else {
      api.reload('47c86822', component.options)
    }
    module.hot.accept("./text-underline.vue?vue&type=template&id=47c86822&scoped=true&", function () {
      api.rerender('47c86822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/text-underline.vue"
export default component.exports